module.exports = __webpack_public_path__ + "img/greengrass.4c0f4c29.jpg";